import {
  UserCogIcon,
  Building2Icon,
  DropletIcon,
  MapPinIcon,
  SmartphoneIcon,
  PillIcon,
  MapIcon,
  InfoIcon,
  UserIcon,
  BellIcon,
  BookIcon,
  LanguagesIcon,
  TicketIcon,
  MessageCircleIcon,
  HospitalIcon,
  CheckCircleIcon,
  ListIcon,
  GiftIcon,
  PackageIcon,
  ImageIcon,
} from 'lucide-react'
import type { NavLinks } from '@/@diffrag/sidebar/type'
import { AdminRole } from '@/constants/adminRole'

export const sideBarNavs: NavLinks[] = [
  {
    label: '메인',
    to: '/main',
    icon: <UserCogIcon size={14} />,
  },
  // {
  //   label: '통계',
  //   icon: <DropletIcon size={14} />,
  //   sub: [
  //     {
  //       label: '수익 통계',
  //       to: '/admin/tanks',
  //     },
  //   ],
  // },
  {
    label: '추천인 실적',
    icon: <DropletIcon size={14} />,
    to: '/referral-stats',
    roles: [AdminRole.SUPER_ADMIN, AdminRole.PARTNER_ADMIN],
    highlight: true,
  },
  {
    label: '레퍼럴 URL',
    icon: <GiftIcon size={14} />,
    to: '/referral-partners',
    roles: [AdminRole.SUPER_ADMIN, AdminRole.PARTNER_ADMIN],
    highlight: true,
  },
  {
    label: '상담 신청 내역',
    icon: <MessageCircleIcon size={14} />,
    to: '/consultation-requests',
    roles: [AdminRole.SUPER_ADMIN],
    highlight: true,
  },
  {
    label: '관리자 관리',
    icon: <UserIcon size={14} />,
    to: '/admin',
    roles: [AdminRole.SUPER_ADMIN],
  },
  {
    label: '회원 관리',
    icon: <UserIcon size={14} />,
    to: '/users',
  },
  {
    label: '제휴문의 관리',
    icon: <MessageCircleIcon size={14} />,
    to: '/inquiry',
  },
  {
    label: '제휴병원 관리',
    icon: <HospitalIcon size={14} />,
    to: '/clinics',
  },
  {
    label: '게시글 승인 관리',
    icon: <CheckCircleIcon size={14} />,
    sub: [
      {
        label: '원장님 인터뷰',
        to: '/approval-management/doctor-interview',
      },
      {
        label: '신규 장비 런칭',
        to: '/approval-management/new-equipment',
      },
    ],
  },
  {
    label: '카테고리 관리',
    icon: <ListIcon size={14} />,
    to: '/categories',
  },
  {
    label: '지역 관리',
    icon: <MapPinIcon size={14} />,
    to: '/regions',
  },
  {
    label: 'Q&A',
    icon: <Building2Icon size={14} />,
    to: '/qna',
  },
  {
    label: '공지사항',
    icon: <Building2Icon size={14} />,
    to: '/notice',
  },
  {
    label: '자주 묻는 질문',
    icon: <Building2Icon size={14} />,
    to: '/faq',
  },
  {
    label: '신고 관리',
    icon: <BellIcon size={14} />,
    to: '/report',
  },
  {
    label: '프로모션 관리',
    icon: <TicketIcon size={14} />,
    to: '/promotion',
  },
  {
    label: '체험단 관리',
    icon: <TicketIcon size={14} />,
    to: '/experience',
  },
  {
    label: '커뮤니티 관리',
    icon: <MessageCircleIcon size={14} />,
    to: '/community',
  },
  {
    label: '댓글 관리',
    icon: <MessageCircleIcon size={14} />,
    to: '/comment',
  },

  {
    label: '포인트 관리',
    icon: <GiftIcon size={14} />,
    sub: [
      {
        label: '포인트 적립 규칙',
        to: '/point',
      },
      {
        label: '포인트 거래 내역',
        to: '/point-transaction',
      },
    ],
  },
  {
    label: '상품 관리',
    icon: <PackageIcon size={14} />,
    to: '/products',
  },
  {
    label: '배너 관리',
    icon: <ImageIcon size={14} />,
    to: '/banner',
  },
  {
    label: '언어 관리',
    icon: <LanguagesIcon size={14} />,
    to: '/translation',
  },
  {
    label: '푸터 아이콘 관리',
    icon: <ImageIcon size={14} />,
    to: '/footer',
  },
]
